import React from "react";
import { createUseStyles, useTheme } from "react-jss";

import NavLinks from './NavLinks';

const useStyles = createUseStyles(theme => ({
  desktopNav: {
    display: 'none',
    [`@media(min-width: 760px)`]: {
      display: 'block'
    }
  }
}));


const DesktopNav = () => {
  const theme = useTheme();
  const styles = useStyles({ theme });

  return (
    <>
    </>
  );
};

export default DesktopNav;
